module.exports = "https://static.energy5.com/_next/static/images/electricianBg-9e49c4848c0797fa9b35a06b4a949481.webp";